export default __webpack_public_path__ + "static/media/chart.80786940.svg";